module.exports = __webpack_public_path__ + "img/bg.ae83c852.jpg";